import React from 'react';
import PropTypes from 'prop-types';
import styles from './articleList.module.scss';
import SmartImage from '../smartImage/smartImage';

function ArticleList({ moduleSplit = null, modules = [] }) {
  let containerStyle = 'fullContainer';
  if (moduleSplit === '50%-50%') {
    containerStyle = 'halfContainer';
  } else if (moduleSplit === '75%-25%') {
    containerStyle = 'leftMaxContainer';
  } else if (moduleSplit === '25%-75%') {
    containerStyle = 'rightMaxContainer';
  }

  return (
    <div className={styles.articleList}>
      {modules &&
        modules?.map((module, index) => {
          const key = `two-column-${index}`;
          return (
            <div
              key={key}
              className={`${
                !!module?.modulePosition && styles[`${module.modulePosition}`]
              }
                ${!!containerStyle && styles[`${containerStyle}`]}`}
            >
              {module?.headline && (
                <div className={styles.header}>
                  <h3 className={styles.title}>{module.headline}</h3>
                </div>
              )}
              {module?.items && (
                <div className={styles.listItems}>
                  <ul>
                    {module?.items?.map((item, index1) => {
                      const key1 = `list-${index1}`;
                      return (
                        <li key={key1}>
                          {item?.icon && (
                            <SmartImage
                              src={item.icon?.src}
                              alt={item.icon?.alt}
                              loading="lazy"
                              quality={100}
                            />
                          )}
                          <a href={item?.link}>
                            <span className={styles.itemLabel}>
                              {item?.label}
                            </span>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              {module?.image && (
                <div className={styles.icon}>
                  <SmartImage
                    src={module.image?.src}
                    loading="lazy"
                    alt={module.image?.alt}
                    width={module.image.width}
                    height={module.image.height}
                    quality={100}
                  />
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
}

ArticleList.propTypes = {
  moduleSplit: PropTypes.string,
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      modulePosition: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          link: PropTypes.string,
        })
      ),
      image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
      }),
    })
  ),
};

export default ArticleList;
